import React, {useState,useEffect} from 'react';
import {Link, useNavigate } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { useSelector} from 'react-redux';
import { eventAllApplicationStatus, deleteEventApplication } from '../../Service';
import Swal from "sweetalert2";

export default function Rightbar(props) {
    // my code ref
      let event_id = props.event_id;
      //console.log('right bar ', event_id);
      const navigation = useNavigate();
      const loggedUser = useSelector(store => store.user['user'])
      let user_id = '';
      if(loggedUser){
        user_id = loggedUser.id;
      }
      
      //console.log('user_id19', user_id)
      const [list, setList] = useState([]);
      const [formValues, setFormValues] = useState([]);
      const [formErrors, setFormErrors] = useState({});

      useEffect(() => {
        var userDataForm = new FormData();
        userDataForm.append('user_id', user_id);
        userDataForm.append('event_id', event_id);
        eventAllApplicationStatus(userDataForm).then(res => setHandleExhibitorResponse(res))
      },[]);

      const setHandleExhibitorResponse = (res) => 
      {
        //console.log('right bar 29',res.data.data); 
        setList(res.data.data);
        
      }

      const doDelete = (event_id)=> {

        //alert(event_id);
        
        Swal.fire({
            title: 'Are you sure?',
            text: "Do you want delete this event?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.isConfirmed) {
                let params = { 'event_id': event_id, 'user_id': user_id };
                deleteEventApplication(params).then(res => handleDeleteRes(res, event_id))
            }
          })
        
    }

    const handleDeleteRes = (response, event_id) => {
      //console.log('Delete response', response);
      if(response.data.code==400){ //IF Token Expired......
          const errors = {};
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: response.data.message,
          })
        }else if(response.data.code==200){  //IF Request is Success
       
          Swal.fire(
              'Deleted!',
              'Event Deleted Successfully',
              'success'
            )
            navigation('/Exhibitorhome');
        }
    }

return (
<>  

<Nav className="flex-column pt-2">
<h1>{loggedUser ? loggedUser.name : ''}</h1>
<Nav.Item className="active">
<Nav.Link href={'../eventapplication/'+event_id } >
Guidelines
</Nav.Link>
</Nav.Item>

<Nav.Item>
{ list.guidline==1 ?
<Nav.Link href={"../createProfile/"+ event_id}> Create Profile </Nav.Link> :
<Nav.Link  href="#"> Create Profile</Nav.Link>
}
</Nav.Item>

<Nav.Item>
{ list.guidline==1 ? 
<Nav.Link href={"../boothDetails/"+event_id}>Exhibitor Details </Nav.Link> :
<Nav.Link  href="#"> Exhibitor Details </Nav.Link>
}
</Nav.Item>

<Nav.Item>
{ list.boothdetails==1 ?
<Nav.Link href={"../uploadartwork/"+event_id}> Upload Artwork </Nav.Link> :
<Nav.Link  href="#"> Upload Artwork </Nav.Link>
}
</Nav.Item>

<Nav.Item>
{ list.artwork==1 ?
<Nav.Link href={"../termsandconditions/"+event_id}>Terms & Conditions</Nav.Link> :
<Nav.Link href="#">Terms & Conditions</Nav.Link>
}
</Nav.Item>

<Nav.Item>
{ list.termscondition==1 ?
<Nav.Link href={"../payment/"+event_id}>Payment</Nav.Link> : 
<Nav.Link href="#">Payment</Nav.Link>
}
</Nav.Item>


<h3><strong>Made a mistake?</strong><br/>
<Link to="#" onClick={()=> doDelete(event_id)}>Click Here</Link> to clear application and restart.</h3>
 

</Nav>

</>
);
}

